/* The DetailsModal class is a custom element that
creates a modal window that can be opened and closed by clicking on the summary element */
class DetailsModal extends HTMLElement {
  /**
   * The constructor function is called when the component is created. It sets up the event listeners
   * for the summary toggle and the close button
   */
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  /**
   * It returns true if the detailsContainer element has an open attribute, and false if it doesn't
   * @returns The detailsContainer has the attribute 'open'
   */
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  /**
   * The function prevents the default action of the event, and then checks if the closest details
   * element has the open attribute. If it does, it closes the details element, otherwise it opens it
   * @param event - The event object that triggered the click.
   */
  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  /**
   * If the user clicks outside of the modal, close the modal
   * @param event - The event object that was triggered.
   */
  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  /**
   * The function opens the details element, adds an event listener to the body, and traps focus within
   * the details element
   * @param event - The event that triggered the function.
   */
  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  /**
   * The function removes the trap focus, removes the open attribute from the details container,
   * removes the event listener from the body, and removes the overflow-hidden class from the body
   * @param [focusToggle=true] - This is a boolean value that determines whether or not the focus trap
   * should be removed.
   */
  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
